import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import EquipmentButtonIcons from "../../constants/EquipmentButtonIcon";
import "./Scenario.css";
import { CreateMultipleScenarioCommands, UpdateScenario } from "../../api/api";
import { useNavigate, useParams } from "react-router-dom";
import SelectEquipmentModal from "../modals/SelectEquipmentModal";
import SelectOutputEquipment from "../modals/SelectOutputEquipment";
import SuccessToast from "../toasts/SuccessToast";
import ScenarioRepeat from "../../constants/ScenarioRepeat";
import Select2 from "../select2/Select2";
import ScenarioTimes from "../../constants/ScenarioTimes";
import ScenarioTimerModal from "../modals/ScenarioTimerModal";
import BackButton from "../BackButton";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const Scenario = () => {
  const {
    handleSelectEquipmentModal,
    scenarioCommands,
    setScenarioCommands,
    setAddScenarioCommandDetail,
    handleScenarioTimerModal,
    setScenarioCommandDetail,
    setIsLoading,
    setScenarioTimeCondition,
    scenarios,
    setScenarios,
    devices,
  } = useContext(Context);

  const [commands, setCommands] = useState([]);

  const navigate = useNavigate();
  const { scenario_id } = useParams();
  const [repeat, setRepeat] = useState();
  const [scenarioType, setScenarioType] = useState(1); // 0 => old Scenario; 1 => new Scenario
  const [scenarioDetail, setScenarioDetail] = useState(null);

  const closeSelectEquipmentRef = useRef(null);
  const closeSelectOutputEquipmentRef = useRef(null);

  useEffect(() => {
    // setIsLoading(true);
    // AllScenarioCommand({
    //   scenario_id,
    // }).then(({ data }) => {
    //   if (data.scenario_commands.length) {
    //     setScenarioCommands(data.scenario_commands);
    //   }
    //   setScenarioDetail(data.scenario);
    //   setRepeat(data.scenario.repeat ?? 1);
    //   setIsLoading(false);
    // });

    if (scenarios.length) {
      setRepeat(scenarios.find((scn) => scn.id == scenario_id).repeat ?? 1);
      setScenarioType(scenarios.find((scn) => scn.id == scenario_id).type ?? 1);
      setScenarioDetail(scenarios.find((scn) => scn.id == scenario_id));
    }
    if (scenarioCommands.length) {
      setCommands(
        scenarioCommands.filter(
          (command) => command.scenario_id == scenario_id,
        ),
      );
    }
  }, [scenarioCommands]);

  useEffect(() => {
    if (commands.length > 0 || !devices.length > 0) return;

    const devs = new Map();
    let scenariotype = 1;
    let timeCondition = [];

    commands.forEach((command) => {
      const { device_id } = command;
      let device = devices.find((d) => d.id == command.device_id);
      if (!device) {
        return;
      }
      let fw_version = device.fw_version ?? 1;

      if (!devs.has(device_id)) {
        const isFirstCommand = devs.size === 0 || devs.has(command.device_id);
        devs.set(device_id, isFirstCommand ? 0 : 1);
      }

      if (fw_version < 10) scenariotype = 0;
      if (fw_version < 11 || fw_version == 15) {
        if (!timeCondition.includes(0)) {
          timeCondition.push(0);
          commands.map((cmd) => {
            if (cmd.time == 0) cmd.time = 500;
          });
        }
      }

      devs.set(device_id, devs.get(device_id) + 1);
    });

    for (const count of devs.values()) {
      if (count > 25) {
        scenariotype = 0;
        if (!timeCondition.includes(0)) {
          timeCondition.push(0);
          commands.map((cmd) => {
            if (cmd.time == 0) cmd.time = 500;
          });
        }
      }
    }

    // if (scenarioType != scenariotype && scenarioDetail) {
    //   UpdateScenario({
    //     scenario_id,
    //     name: scenarioDetail.name,
    //     type: scenariotype,
    //     repeat: scenariotype ? repeat : 0,
    //   });
    // }

    setScenarioType(scenariotype);
    setScenarioTimeCondition(timeCondition);
  }, [commands, devices]);

  const handleRemoveScenario = (scenarioCommandId) => {
    // setIsLoading(true);
    // DeleteScenarioCommand({ scenario_command_id: scenarioCommandId }).then(
    //   ({ data }) => {
    //     SuccessToast("دستور با موفقیت حذف گردید");
    //     setScenarioCommands(
    //       scenarioCommands.filter((scn) => scn.id != scenarioCommandId)
    //     );
    //     setIsLoading(false);
    //   }
    // );
    setCommands((prev) =>
      prev.filter((command) => command.id != scenarioCommandId),
    );
  };

  const handleSubmit = () => {
    setIsLoading(true);
    UpdateScenario({
      scenario_id,
      name: scenarioDetail.name,
      type: scenarioType,
      repeat: scenarioType ? repeat : 0,
      icon: scenarioDetail.icon,
    })
      .then(({ data }) => {
        if (!commands.length) {
          return navigate("/planning/scenario-list");
        }
        setScenarios(
          scenarios.map((scn) => {
            if (scn.id == scenario_id) {
              scn.repeat = repeat;
              scn.type = scenarioType;
            }
            return scn;
          }),
        );
        // scenarioCommands.map((cmd) => {
        //   delete cmd.device;
        //   delete cmd.id;
        //   delete cmd.created_at;
        //   delete cmd.updated_at;
        //   return cmd;
        // });
        CreateMultipleScenarioCommands(commands, scenario_id).then(
          ({ data }) => {
            SuccessToast("با موفقیت ثبت شد");
            setScenarioCommands(
              scenarioCommands
                .filter((cmd) => cmd.scenario_id != scenario_id)
                .concat(data.scenario_commands),
            );
            navigate("/planning/scenario-list");
          },
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const renderScenarioCommands = () => {
    if (commands.length && devices.length) {
      return commands.map((command, index) => {
        let device = devices.find((d) => d.id == command.device_id);
        if (!device) {
          return;
        }
        let iconPath = "";
        if (command.icon) {
          let commandIcon = EquipmentButtonIcons.find(
            (icon) => icon.id == command.icon,
          );
          iconPath = commandIcon.path;
        }
        return (
          <div
            className="scenario-equipment position-relative"
            key={command.id}
          >
            <button
              type="button"
              className="btn rounded-pill btn-icon position-absolute text-danger"
              style={{ top: "calc(50% - 36px)", right: "1.5rem" }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleRemoveScenario(command.id);
              }}
            >
              <span className="tf-icons bx bx-trash"></span>
            </button>
            <div className="seperator"></div>
            {command.icon ? (
              <div
                onClick={() => {
                  setScenarioCommandDetail({
                    id: command.id,
                    icon: command.icon,
                    data: command.data,
                    command_name: command.command_name,
                    device_id: command.device_id,
                    time: command.time,
                  });
                  handleSelectEquipmentModal(true);
                }}
              >
                <img className="mt-3" src={iconPath} />
                {device.type == 1 ||
                device.type == 2 ||
                device.type == 7 ||
                device.type == 8 ||
                device.type == 10 ||
                device.type == 11 ||
                device.type == 12 ||
                device.type == 13 ||
                device.type == 14 ||
                device.type == 15 ||
                (command.data1 >= 65 && command.data1 <= 84) ? (
                  <div
                    className={
                      parseInt(command.data2)
                        ? "status-part bg-success mx-auto"
                        : "status-part bg-danger mx-auto"
                    }
                  ></div>
                ) : null}
                <div className="mb-3 mt-2">
                  <span>{command.command_name}</span>
                </div>
              </div>
            ) : (
              <div
                className="command-icon mx-auto my-3 state-0"
                style={{ alignContent: "center" }}
                onClick={() => {
                  setScenarioCommandDetail({
                    id: command.id,
                    icon: command.icon,
                    data: command.data,
                    command_name: command.command_name,
                    device_id: command.device_id,
                    time: command.time,
                  });
                  handleSelectEquipmentModal(true);
                }}
              >
                <div>
                  <span>{command.command_name}</span>
                </div>
              </div>
            )}
            {command.icon ? <p className="m-0 p-0"></p> : null}

            <div className="seperator"></div>
            <div
              className="time"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setScenarioCommandDetail(command);
                handleScenarioTimerModal(true);
              }}
            >
              {ScenarioTimes.find((i) => i.value == command.time).name}
            </div>
          </div>
        );
      });
    }
  };

  return (
    <div
      className="card h-100"
      style={{ backgroundColor: "#fff0", boxShadow: "none" }}
    >
      <div className="card-header d-flex align-items-center justify-content-between border-bottom mb-3 p-0 pt-2">
        <h5>{scenarios.find((s) => s.id == scenario_id)?.name ?? "سناریو"}</h5>
        <div>
          <button
            type="button"
            className="btn btn-icon btn-success-app"
            onClick={handleSubmit}
          >
            <span className="tf-icons bx bx-check"></span>
          </button>
          <BackButton url={"/planning/scenario-list/"} />
        </div>
      </div>
      <div className="card-body scrollbar">
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "1.5rem" }}> */}
        <div
          className="add-equipment"
          onClick={(e) => {
            setScenarioCommandDetail({});
            handleSelectEquipmentModal(true);
            setAddScenarioCommandDetail((preveState) => ({
              ...preveState,
              scenario_id,
            }));
          }}
        >
          <i className="bx bx-plus"></i>
        </div>
        {scenarioType ? (
          <div className="repeat ms-auto" style={{ left: "3px" }}>
            <div className="">
              <span className="">دفعات اجرا:</span>
            </div>
            <Select2
              options={ScenarioRepeat}
              setValue={setRepeat}
              value={repeat}
              parentElem={"body"}
            />
          </div>
        ) : null}

        <div className="scenario-equipments">{renderScenarioCommands()}</div>
        {/* </SimpleBar> */}
      </div>

      <SelectEquipmentModal
        mode={"scenario"}
        closeSelectEquipmentRef={closeSelectEquipmentRef}
        closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
      />
      <SelectOutputEquipment
        closeSelectEquipmentRef={closeSelectEquipmentRef}
        closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
        scenarioCommands={scenarioCommands}
        setScenarioCommands={setScenarioCommands}
        scenarioType={scenarioType}
        setCommands={setCommands}
        commands={commands}
      />
      <ScenarioTimerModal commands={commands} setCommands={setCommands} />
    </div>
  );
};

export default Scenario;
